<template>
  <div class="col q-mini-drawer-hide">
    <scroll-area class="fit">
      <q-list sparator class="tree tree--project">
        <expansion-item
            expand-icon-toggle
            class="tree__item tree_item--active"
            default-opened
        >
          <template v-slot:header>
            <div class="heading-4 cursor-pointer"
                 @click="$goto('project.show',  {project_id : project.latest_version.project_id})">
              {{ project.latest_version.title }}
            </div>
          </template>
          <q-list separator class="tree">
            <template v-for="phase in project.phases" :key="phase.id">
              <expansion-item
                  v-if="currentPhase(phase)"
                  expand-icon-toggle
                  switch-toggle-side
                  default-opened
                  class="tree__item"
                  :class="{'text-weight-bold': currentPhase(phase)}"
                  :content-inset-level="1.6"
              >
                <template v-slot:header>
                  <div class="row items-center">
                    <status-dot :status="$phaseStatusColor(phase.pivot.status)" class="q-mr-md" />
                    <common-link :label="phase.title"
                                 active
                                 :href="$route('project.rule.index', {project_id: project.latest_version.project_id, phase_id: phase.id})" />
                  </div>
                </template>
                <q-list separator class="tree">
                  <template v-for="category in projectRules.categories" :key="phase.id">
                    <q-item class="text-weight-regular">
                      <common-link :label="category.title"
                                   is-local
                                   :href="`#category-${category.id}`" />
                    </q-item>
                  </template>
                </q-list>
              </expansion-item>
              <item-link v-else :href="$route('project.rule.index', {project_id: project.id, phase_id: phase.id})">
                <div class="row items-center position-relative q-pl-md"
                     :style="hasExpandablePhase ? 'padding-left: 40px': ''">
                  <status-dot :status="$phaseStatusColor(phase.pivot.status)" class="q-mr-md" />
                  {{ phase.title }}
                </div>
              </item-link>
            </template>
          </q-list>
        </expansion-item>
      </q-list>
    </scroll-area>
  </div>
</template>

<script>
import { phaseStatusMixin } from '~HIOR/mixins'
import { useProjectRules } from '../../stores/useProjectRules'

export default {
  setup () {
    const projectRules = useProjectRules()
    return {
      projectRules,
    }
  },
  mixins: [phaseStatusMixin],
  props: {
    project: {
      type: Object,
    },
    phases: {
      type: Array,
      default: () => [],
    },
    objectGroups: {
      type: Object,
      default: () => ({}),
    },
    ruleVersions: {
      type: Object,
      default: () => ({}),
    },
    rules: {
      type: Array,
      default: () => [],
    },
    phase: {
      type: Object,
      default: undefined,
    },
    showIrrelevant: {
      type: Boolean,
      default: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    expandable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasExpandablePhase () {
      return !!this.phase
    },
  },
  methods: {
    currentPhase (phase) {
      if (!this.phase) {
        return false
      }

      return this.phase.id === phase.id
    },
  },
}
</script>
